export const packageID = 'startracex-flarum-dark';
